import apiClient from '../../../Services/ApiClient';
import { Document } from '../../../graphql/graphql';
import { DiscourseValues } from './DiscourseContext';
import { DocumentContentSubType } from '../../Documents/Enums/documentContentSubType.enum';

export const saveDiscourse = async (activeDiscourseId: string) => {
	return await apiClient.patch(`/document/${activeDiscourseId}`, {
		type: 'DEKURZ',
	});
};

export const discardDiscourse = async (activeDiscourseId: string) => {
	return await apiClient.patch(`/document/${activeDiscourseId}`, {
		type: 'DEKURZ_DISCARTED',
	});
};

export const stashDiscourse = async (activeDiscourseId: string, data: any) => {
	return await apiClient.patch(`/document/${activeDiscourseId}`, data);
};

export const deleteDiscourseAttachment = async (
	activeDiscourseId: string,
	attachmentId: string,
) => {
	return await apiClient.delete(
		`/document/${activeDiscourseId}/item/${attachmentId}`,
	);
};

export const initializeNewDiscourse = async (
	workplaceId: string,
	patientId: string,
	loggedUserId: string,
	data?: object,
) => {
	return await apiClient.post('/document/', {
		workplaceId,
		userId: patientId,
		createdById: loggedUserId,
		type: 'DEKURZ_DRAFT',
		children: data,
	});
};

export const attachToDiscourse = async (
	activeDiscourseId: string,
	attachmentId: string,
	type: string,
	title: string,
	sentToPatient: boolean,
) => {
	return await apiClient.post(`/document/${activeDiscourseId}/item`, {
		type: type,
		extra: {
			id: attachmentId,
			title,
			sentToPatient: sentToPatient,
		},
	});
};

/**
 * Attaches prescription to dekurz draft
 * @param activeDiscourseId 
 * @param prescriptionId 
 * @returns {Promise}
 */
export const attachPrescription = async (
	activeDiscourseId: string,
	prescriptionId: string,
) => {
	return await apiClient.post(`/document/${activeDiscourseId}/item`, {
		type: 'prescription',
		extra: {
			id: prescriptionId
		},
	});
}

export const prepareDefaultValues = (document: Document) => {
	return {
		text: document?.items?.find(item => item?.type === 'content')?.extra?.text,
		diagnosis: document?.items?.find(
			item =>
				item?.type === 'diagnosis' && item?.extra?.subType === 'main_diagnosis',
		)?.extra?.text,
		diagnoses: document?.items
			?.filter(
				item =>
					item?.type === 'diagnosis' &&
					item?.extra?.subType === 'secondary_diagnosis',
			)
			.map(item => {
				return { secondaryDiagnosis: item?.extra?.text };
			}),
		discourseId: document?.id,
	};
};

export const prepareDiscourseItems = (
	values: DiscourseValues,
	raw: boolean = false,
) => {
	const data: { children: object[] } = {
		children: [
			{
				type: 'content',
				extra: {
					text: values.text,
				},
			},
		],
	};

	if (values.diagnosis) {
		if (values.diagnosis?.label && values.diagnosis?.value) {
			data.children.push({
				type: 'diagnosis',
				extra: {
					text: values.diagnosis,
					subType: DocumentContentSubType.MAIN_DIAGNOSIS,
				},
			});
		}
	}

	if (values.diagnoses) {
		values.diagnoses.forEach(item => {
			if (item?.secondaryDiagnosis?.label && item?.secondaryDiagnosis?.value) {
				data.children.push({
					type: 'diagnosis',
					extra: {
						text: item?.secondaryDiagnosis,
						subType: DocumentContentSubType.SECONDARY_DIAGNOSIS,
					},
				});
			}
		});
	}

	if (raw) {
		return data?.children;
	}

	return data;
};
